export const HOST = 'https://api.crosspunks.com';
